import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const LegacyDropDown = function LegacyDropDown({ trigger, options }) {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const toggleRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!dropdownRef.current?.contains(event.target)
                && !toggleRef.current?.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
    }, [dropdownRef]);

    return (
        <div className={`navbar-item has-dropdown ${open && 'is-active'} ${styles['legacy-dropdown']}`}>
            <div className={styles.toggle} ref={toggleRef} onClick={() => setOpen(!open)} role="listbox" tabIndex={0}>
                {trigger}
            </div>
            <div className={`${styles.options} navbar-dropdown`} ref={dropdownRef}>
                {options.map((o, i) => (o.href
                    ? (
                        <div key={o.href}>
                            <a className={`navbar-item ${styles.option}`} href={o.href}>{o.value}</a>
                            {i < (options.length - 1) ? <hr className="navbar-divider" /> : null}
                        </div>
                    ) : null
                ))}
            </div>
        </div>
    );
};

LegacyDropDown.propTypes = {
    trigger: PropTypes.node.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node,
            ]),
        }),
    ).isRequired,
};

LegacyDropDown.defaultProps = {
};

export default LegacyDropDown;
